// https://sistemas.ucasal.edu.ar/sagbackend/api/v1/registro-inicial/lovs/lugares2?tipo-estudio=Grado&carrera=${id_carrera}

import { SERVICES_URL_MICRO } from "../../config/config";
import { connection } from "../../utils/connection";


const getListPlaces = async ({ token, callbacks, params }) => {
    // const res= await fetch('http://localhost:8081/v1/ingresos/2025/' +'Grado?output=lovs&codigoCarrera='+params.carrera)
    const res= await fetch(SERVICES_URL_MICRO.PLACES.LIST+'Grado?output=lovs&codigoCarrera='+params.carrera)
    const data = await res.json();
    if (typeof callbacks === "function") {
        callbacks(data);
    }
}

export default getListPlaces;

